import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from '@/components/ui/input-group';
import { cn } from '@/lib/utils';
import { MessageSquareIcon, SearchIcon, TerminalIcon, WalletIcon, XIcon } from 'lucide-react';

export type ClientFeedTab = 'balances' | 'sms' | 'commands';

interface ClientFeedTabsProps {
	listType: ClientFeedTab;
	onListTypeChange: (value: ClientFeedTab) => void;
	searchText: string;
	onSearchChange: (value: string) => void;
	counts?: { balances: number; sms: number; commands: number };
}

function formatTabLabel(label: string, count?: number) {
	if (count != null && count > 0) return `${label} (${count})`;
	return label;
}

const SEARCH_PLACEHOLDERS: Record<ClientFeedTab, string> = {
	balances: 'Текст, карта, SIM…',
	sms: 'Текст SMS, SIM…',
	commands: 'Тип, текст, номер…',
};

const TABS: { id: ClientFeedTab; label: string; icon: typeof WalletIcon }[] = [
	{ id: 'balances', label: 'Балансы', icon: WalletIcon },
	{ id: 'sms', label: 'SMS', icon: MessageSquareIcon },
	{ id: 'commands', label: 'Команды', icon: TerminalIcon },
];

export default function ClientFeedTabs({ listType, onListTypeChange, searchText, onSearchChange, counts }: ClientFeedTabsProps) {
	const countMap: Record<ClientFeedTab, number | undefined> = {
		balances: counts?.balances,
		sms: counts?.sms,
		commands: counts?.commands,
	};

	return (
		<div className='flex flex-col gap-2 px-2 py-2'>
			<div className='flex gap-1.5 overflow-x-auto scrollbar-hide'>
				{TABS.map(tab => {
					const Icon = tab.icon;
					const active = listType === tab.id;
					return (
						<button
							key={tab.id}
							type='button'
							onClick={() => onListTypeChange(tab.id)}
							className={cn(
								'shrink-0 h-9 px-3.5 rounded-lg border text-sm inline-flex items-center gap-1.5 transition-colors',
								active
									? 'bg-secondary border-border text-foreground font-semibold shadow-sm'
									: 'border-border/60 bg-card/40 text-muted-foreground hover:bg-accent',
							)}
						>
							<Icon size={16} className={cn(active && 'text-chart-2')} />
							{formatTabLabel(tab.label, countMap[tab.id])}
						</button>
					);
				})}
			</div>

			<InputGroup className='h-10 rounded-lg bg-muted/30 shadow-sm'>
				<InputGroupAddon align='inline-start'>
					<SearchIcon size={18} className='opacity-50' />
				</InputGroupAddon>
				<InputGroupInput
					className='text-base'
					placeholder={SEARCH_PLACEHOLDERS[listType]}
					value={searchText}
					onChange={e => onSearchChange(e.target.value)}
				/>
				{searchText ? (
					<InputGroupAddon align='inline-end'>
						<InputGroupButton size='icon-xs' aria-label='Очистить' onClick={() => onSearchChange('')}>
							<XIcon />
						</InputGroupButton>
					</InputGroupAddon>
				) : null}
			</InputGroup>
		</div>
	);
}
